"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCameraNameFromId = getCameraNameFromId;
exports.getMicrophoneNameFromId = getMicrophoneNameFromId;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/**
 * Get the label (name) of a camera device given its deviceId.
 * @param {string} deviceId - The deviceId of the camera.
 */
function getCameraNameFromId(_x) {
  return _getCameraNameFromId.apply(this, arguments);
}
/**
 * Get the label (name) of a microphone device given its deviceId.
 * @param {string} deviceId - The deviceId of the microphone.
 */
function _getCameraNameFromId() {
  _getCameraNameFromId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(deviceId) {
    var devices, camera;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return navigator.mediaDevices.enumerateDevices();
        case 2:
          devices = _context.sent;
          camera = devices.find(function (d) {
            return d.kind === 'videoinput' && d.deviceId === deviceId;
          });
          return _context.abrupt("return", camera === null || camera === void 0 ? void 0 : camera.label);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getCameraNameFromId.apply(this, arguments);
}
function getMicrophoneNameFromId(_x2) {
  return _getMicrophoneNameFromId.apply(this, arguments);
}
function _getMicrophoneNameFromId() {
  _getMicrophoneNameFromId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(deviceId) {
    var devices, mic;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return navigator.mediaDevices.enumerateDevices();
        case 2:
          devices = _context2.sent;
          mic = devices.find(function (d) {
            return d.kind === 'audioinput' && d.deviceId === deviceId;
          });
          return _context2.abrupt("return", mic === null || mic === void 0 ? void 0 : mic.label);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getMicrophoneNameFromId.apply(this, arguments);
}